.checkbox {
    font-size: var(--font-normal);
    color: var(--grey);
    margin-bottom: 8px;
}
